import React from "react"
const Button = ({
  children,
  className = false,
  id = false,
  variant,
  size,
  href,
  type,
  dataBsDismiss,
  dataBsToggle,
  dataBsTarget
}) => {
  let newType = null
  className = `btn ${className ? `${className} ` : ""}${
    variant ? ` btn-${variant}` : ""
  }${size ? ` btn-${size}` : ""}`
  let as = ""
  if (dataBsTarget) dataBsTarget = "#" + dataBsTarget
  type = `${type ? `${type}`:"button"}`
  if (!href) {
    as = "button"
    newType = null
  } else { 
    as = "a"
    newType = "button"
    type = null
  }
  return React.createElement(
    as,
    {
      "href": href, 
      "className": className,
      "type": type,
      "role": newType,
      "data-bs-dismiss": dataBsDismiss,
      "data-bs-toggle": dataBsToggle,
      "data-bs-target": dataBsTarget
    },
    children
  )
}
export default Button
